/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

/**
 * RedirectMFAPage is a special page that is used to handle the redirect from a MFA flow.
 * It retrieves the code and state from the query parameters and stores them in session storage.
 * Then it retrieves the step, redirect origin, and redirect query from the session storage.
 * If the step is valid and the redirect origin is present, it redirects the user back to the
 * original page with the code and state added to the query parameters.
 * The page is then unmounted to prevent the user from accessing it again.
 */
const RedirectMFAPage = () => {
    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        const code = queryParams.get('code') || '';
        const state = queryParams.get('state') || '';

        sessionStorage.setItem('mfacode', code);
        sessionStorage.setItem('mfastate', state);

        const stepString = sessionStorage.getItem('step');
        const redirectOrigin = sessionStorage.getItem('redirectOrgin');
        const redirectQuery = sessionStorage.getItem('redirectQuery');
        const tree = sessionStorage.getItem('authIndexValue');

        if (stepString) {
            const step = JSON.parse(stepString);
            if (step && step.payload && redirectOrigin) {
                const goto = redirectQuery ? new URLSearchParams(redirectQuery).get('goto') || '' : '';

                const queryParam = !!goto
                    ? `?code=${code}&state=${state}&authIndexValue=${tree}`
                    : `?code=${code}&state=${state}&authIndexValue=${tree}`;

                window.location.href = `${redirectOrigin}${redirectQuery}`;
            }
        }
    }, []);

  
    return (<></>)
};

export default RedirectMFAPage;